/** Matches backend AssignmentReasonStatus enum: Enabled = 1, Disabled = 2 */
export const AssignmentReasonStatus = {
    Locked: 0,
    Enabled: 1,
    Disabled: 2
};
